class BlogLoadMore {
  constructor() {
    this.loadMoreButtons = document.querySelectorAll('[data-blog-load-more]');
    this.init();
  }

  init() {
    this.loadMoreButtons.forEach(button => {
      button.addEventListener('click', this.handleLoadMore.bind(this));
    });
  }

  async handleLoadMore(event) {
    event.preventDefault();
    
    const button = event.currentTarget;
    const nextUrl = button.dataset.nextUrl;
    const articlesContainer = document.querySelector('[data-blog-articles]');
    
    if (!nextUrl || !articlesContainer) return;
    
    // Show loading state
    button.disabled = true;
    button.innerHTML = '<span>Loading...</span>';
    
    try {
      const response = await fetch(nextUrl);
      const html = await response.text();
      
      // Create a temporary container to parse the response
      const tempContainer = document.createElement('div');
      tempContainer.innerHTML = html;
      
      // Extract the new articles
      const newArticles = tempContainer.querySelector('[data-blog-articles]');
      const newShowMoreButton = tempContainer.querySelector('[data-blog-load-more]');
      
      if (newArticles) {
        // Append new articles to existing container
        const newArticlesList = newArticles.querySelector('.blog-listing');
        if (newArticlesList) {
          const existingArticlesList = articlesContainer.querySelector('.blog-listing');
          if (existingArticlesList) {
            // Append individual articles
            const newArticleItems = newArticlesList.querySelectorAll('.article');
            newArticleItems.forEach(article => {
              existingArticlesList.appendChild(article);
            });
          } else {
            // If no existing list, append the whole list
            articlesContainer.appendChild(newArticlesList);
          }
        }
        
        // Update or remove the show more button
        if (newShowMoreButton) {
          // Update button with new URL
          button.dataset.nextUrl = newShowMoreButton.dataset.nextUrl;
          button.disabled = false;
          button.innerHTML = '<span>Show more</span>';
        } else {
          // No more pages - remove button
          button.parentElement.remove();
        }
      } else {
        // No more articles - remove button
        button.parentElement.remove();
      }
      
    } catch (error) {
      console.error('Error loading more articles:', error);
      // Reset button state
      button.disabled = false;
      button.innerHTML = '<span>Show more</span>';
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new BlogLoadMore();
});